module.exports = __webpack_public_path__ + "static/grafika14-1653994996091f17f9f5c5785f52ff47.png";